export const _WEBSITE_VERSION = 'us'
export const _LOCAL_BUILD = false
export const _LAB_BUILD = false



// WEBPACK FOOTER //
// ./src/constants/global/config.js